import React from "react";
import { Animated, StyleProp, TextStyle, ViewStyle } from "react-native";
import SVG_Svg, { Color, GProps, PathProps, G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="164" height="164" viewBox="0 0 164 164" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="iconmonstr-gear-1 1">
 * <path id="Vector" d="M164 93.0427V70.9573C152.718 66.9462 145.591 65.8187 142.004 57.1608V57.154C138.402 48.4688 142.687 42.5717 147.791 31.8228L132.177 16.2087C121.51 21.279 115.552 25.6045 106.846 21.9965H106.839C98.1677 18.4022 97.0333 11.2272 93.0427 0H70.9573C66.9803 11.1725 65.8392 18.3953 57.1608 21.9965H57.154C48.4688 25.6045 42.5853 21.3268 31.8228 16.2087L16.2087 31.8228C21.2995 42.5375 25.6045 48.4552 21.9965 57.154C18.3953 65.8392 11.1725 66.9803 0 70.9573V93.0427C11.152 97.006 18.3953 98.1608 21.9965 106.839C25.6182 115.6 21.2175 121.64 16.2087 132.17L31.8228 147.791C42.4965 142.714 48.4552 138.396 57.154 142.004H57.1608C65.8392 145.598 66.9735 152.793 70.9573 164H93.0427C97.0197 152.821 98.1677 145.618 106.894 141.983H106.901C115.524 138.402 121.387 142.673 132.17 147.798L147.785 132.177C142.701 121.497 138.389 115.552 141.99 106.853C145.591 98.1677 152.841 97.0128 164 93.0427V93.0427ZM82 109.333C66.9052 109.333 54.6667 97.0948 54.6667 82C54.6667 66.9052 66.9052 54.6667 82 54.6667C97.0948 54.6667 109.333 66.9052 109.333 82C109.333 97.0948 97.0948 109.333 82 109.333Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const iconmonstr_gear_1_1 = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
  color: Color;
}): JSX.Element => {
  const { svgRef } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 164 164" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="iconmonstr_gear_1_201">
        <Path
          id="Vector"
          d="M164 93.0427V70.9573C152.718 66.9462 145.591 65.8187 142.004 57.1608V57.154C138.402 48.4688 142.687 42.5717 147.791 31.8228L132.177 16.2087C121.51 21.279 115.552 25.6045 106.846 21.9965H106.839C98.1677 18.4022 97.0333 11.2272 93.0427 0H70.9573C66.9803 11.1725 65.8392 18.3953 57.1608 21.9965H57.154C48.4688 25.6045 42.5853 21.3268 31.8228 16.2087L16.2087 31.8228C21.2995 42.5375 25.6045 48.4552 21.9965 57.154C18.3953 65.8392 11.1725 66.9803 0 70.9573V93.0427C11.152 97.006 18.3953 98.1608 21.9965 106.839C25.6182 115.6 21.2175 121.64 16.2087 132.17L31.8228 147.791C42.4965 142.714 48.4552 138.396 57.154 142.004H57.1608C65.8392 145.598 66.9735 152.793 70.9573 164H93.0427C97.0197 152.821 98.1677 145.618 106.894 141.983H106.901C115.524 138.402 121.387 142.673 132.17 147.798L147.785 132.177C142.701 121.497 138.389 115.552 141.99 106.853C145.591 98.1677 152.841 97.0128 164 93.0427V93.0427ZM82 109.333C66.9052 109.333 54.6667 97.0948 54.6667 82C54.6667 66.9052 66.9052 54.6667 82 54.6667C97.0948 54.6667 109.333 66.9052 109.333 82C109.333 97.0948 97.0948 109.333 82 109.333Z"
          fill={props.color}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(iconmonstr_gear_1_1);
